import { render, staticRenderFns } from "./CheckQueryDetail.vue?vue&type=template&id=174dcad4&scoped=true"
import script from "./CheckQueryDetail.vue?vue&type=script&lang=js"
export * from "./CheckQueryDetail.vue?vue&type=script&lang=js"
import style0 from "./CheckQueryDetail.vue?vue&type=style&index=0&id=174dcad4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174dcad4",
  null
  
)

export default component.exports